import type { TrpcFetch } from "./trpc-fetch";

export const trpcMaxUrlLength = 6000;

interface TrpcBatchLinkOptions {
    url: string;
    fetch: TrpcFetch;
    maxURLLength: number;
}

export const trpcBatchLinkOptions = (
    url: string,
    fetchImpl: TrpcFetch,
): TrpcBatchLinkOptions => ({
    url,
    fetch: fetchImpl,
    maxURLLength: trpcMaxUrlLength,
});
